import { render, staticRenderFns } from "./OptimizationMarkdownOverlay.vue?vue&type=template&id=5c97748a&scoped=true"
import script from "./OptimizationMarkdownOverlay.vue?vue&type=script&lang=js"
export * from "./OptimizationMarkdownOverlay.vue?vue&type=script&lang=js"
import style0 from "./OptimizationMarkdownOverlay.vue?vue&type=style&index=0&id=5c97748a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c97748a",
  null
  
)

export default component.exports